import React from "react";
import { Link } from "react-router-dom";

const FooterTwo = () => {
  return (
    <footer>
      <div className="footer-area-two">
        <div className="container">
          <div className="footer-top-two">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-8">
                <div className="footer-content-two text-center">
                  <div className="logo">
                    <Link to="/">
                    <img src="/img/logo/logo.png" alt="Vernu Stoffering logo" />
                    </Link>
                  </div>
                  <p>
                  Vernu Stoffering in Rotterdam biedt vakkundige
                  herstellingen en aanpassingen van stoelen, fauteuils en banken. De Snelste en meest Betrouwbare Stoffeerderij met oog voor detail.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom-two">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="copyright-text">
                <p>© {new Date().getFullYear()}, Vernu Stoffering Rotterdam</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="footer-social-two">
                  <ul className="list-wrap">
                  
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
